const defaultRouter = [
  {
    path: '/',
    component: () => import('@/layout'),
    children: [
      {
        path: 'logisticsSide', // 物流通全球
        name: 'LogisticsSide',
        meta: { title: '物流通全球' },
        component: () => import(/* webpackChunkName: "logistics" */ '@/pages/logisticsSide')
      },
      {
        path: 'welcomeToYiwu', // 欢迎来义乌
        name: 'WelcomeToYiwu',
        meta: { title: '欢迎来义乌' },
        component: () => import(/* webpackChunkName: "misc" */ '@/pages/welcomeToYiwu')
      },
      {
        path: 'identifier',
        name: 'Identifier',
        meta: { title: '金融帮您办' },
        component: () => import(/* webpackChunkName: "misc" */ '@/pages/Identifier')
      },
      {
        path: 'financehelp', // 金融帮您办
        name: 'Financehelp',
        meta: { title: '金融帮您办' },
        component: () => import(/* webpackChunkName: "misc" */ '@/pages/financeHelp')
      },
      {
        path: 'act/:UniqueId',
        name: 'Act',
        meta: { title: '会场' },
        component: () => import(/* webpackChunkName: "act" */ '@/pages/act/index')
      }
    ]
  },
  {
    path: '/hotel/hotelPayPage', // 酒店支付页面
    name: 'HotelPayPage',
    meta: { title: '酒店支付页面' },
    component: () =>
      import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel/hotelPayPage')
  },
  {
    path: '/kyb/:domainId', // 酒店支付页面
    name: 'kyb',
    meta: { title: 'KYB店铺页' },
    component: () =>
      import(/* webpackChunkName: "kyb" */ '@/pages/shop/detail')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import('@/layout'),
    children: [
      {
        path: '',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/pages/404')
      }
    ]
  },
  {
    path: '/error',
    component: () => import('@/layout'),
    children: [
      {
        path: '',
        name: 'error',
        component: () => import('@/pages/404/error')
      }
    ]
  },
  {
    path: '/transfer',
    component: () => import('@/pages/transfer/layout'),
    children: [
      {
        path: '',
        name: 'transfer',
        component: () => import(/* webpackChunkName: "transfer" */ '@/pages/transfer')
      }
    ]
  },
  {
    path: '/perform',
    component: () => import('@/layout'),
    children: [
      {
        path: '',
        name: 'Perform',
        component: () => import(/* webpackChunkName: "misc" */ '@/pages/perform'),
        meta: {
          breadcrumb: {
            name: '首页',
            path: '/',
            isOut: false,
            children: {
              name: '小商品城网络文化',
              path: '',
              isOut: false
            }
          }
        }
      }
    ]
  }
]

export default defaultRouter
